import createReactClass from 'create-react-class';
('use strict');

// Import Libraries
import React from 'react';

// -----------------------------------------------------------
//  NoResults
// -----------------------------------------------------------
var NoResults = createReactClass({
  render: function() {
    return (
      <div className="no-results">
        <div className="noresult">
          <div className="no-result-image"></div>
          <h2>We couldn't find a match</h2>
          <p>Let's clear your filters and start over.</p>
        </div>
        <button
          className="btn btn-primary btn-lg"
          onClick={this.props.onClearAllFilters}>
          {' '}
          Clear filters
        </button>
      </div>
    );
  },
});

export default NoResults;
